"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configMercadoPago = configMercadoPago;
exports.load = load;
var _loadScript = _interopRequireDefault(require("../loadScript"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
let _loadPromise;
const PROMISE_VOID = Promise.resolve();
function load() {
  if (window['MercadoPago']) {
    return PROMISE_VOID;
  }
  if (!_loadPromise) {
    _loadPromise = new Promise((res, rej) => {
      (0, _loadScript.default)('https://sdk.mercadopago.com/js/v2', () => {
        if (window['MercadoPago']) {
          res();
        } else {
          rej('MercadoPago not available');
        }
      });
    });
  }
  return _loadPromise;
}
async function configMercadoPago(params) {
  const {
    publicKey,
    ...options
  } = params;
  await load();
  const MercadoPago = window['MercadoPago'];
  const mp = new MercadoPago(publicKey, options);
  return mp;
}